import { ClinicInfo } from "@smile2impress/location-content";
import {
    ITimeSlotDayResponseDTO,
    ITimeSlotItemResponseDTO,
} from "@smile2impress/web-types";
import { ErrorsResponseType, StatusesResponseType } from "api/constants";

export type TimeslotType = ITimeSlotItemResponseDTO & { isBookable: boolean };

export type TimeslotsType = ITimeSlotDayResponseDTO & { slots: TimeslotType[] };

export type ClinicWithTimeslots = ClinicInfo & {
    priority: number;
    timezone: string;
    timeslots: TimeslotsType[];
};

export type CityWithClinicsAndTimeslotsType = {
    id: number;
    title: string;
    label: string | null;
    regionId: number;
    clinics: ClinicWithTimeslots[];
    clinicIds: number[];
};

export interface UserLocationCityResponse {
    result: {
        city: string;
    };
}

export enum ClinicType {
    Teens = "teens",
    Adults = "adults",
    Combined = "combined",
}

export type ClinicWithCityTitleProps = ClinicInfo & {
    cityTitle: string;
};

export enum DistanceType {
    KM = "KM",
    MI = "MI",
}
export interface DistanceInfo {
    unit: DistanceType;
    value: number;
}

export type ClinicWithDistanceInfo = ClinicInfo & {
    distance: DistanceInfo;
};

export interface GetClinicByClinicIdType {
    clinicId: number;
}

export interface GetClinicByClinicIdResponse {
    data: ClinicDateType | null;
    status: StatusesResponseType;
    error: ErrorsResponseType;
}

export interface GetClinicsByPostcodeResponse {
    data: ClinicWithDistanceInfo[] | null;
    status: StatusesResponseType;
    error: ErrorsResponseType;
}

export interface ClinicDateType {
    id: number;
    title: string;
    address: string;
    region: {
        title: string;
        timezone: string;
    };
    city: {
        id: number;
        title: string;
    };
    geoData: {
        googleMapClinicUrl: string | null;
        googleMapParkingUrl: string | null;
        latitude: string;
        longitude: string;
    };

    uses_internal_mail_engine?: boolean;
    country?: {
        title: string;
        code: string;
    };
}

export interface CityWithClinicsAndTimeslotsResponse {
    data: CityWithClinicsAndTimeslotsType | null;
    status: StatusesResponseType;
    error: ErrorsResponseType;
}

export interface CityByGeo {
    id: number;
    title: string;
    regionId: number;

    code?: string;
    label?: string | null;
    clinicIds?: number[];
    // Data is too complicated and we don't use it anyway
    clinics?: any[];
}

export interface GetAttractionClinicsResponse {
    data: {
        items: AttractionClinic[] | null;
        status: StatusesResponseType;
        error: ErrorsResponseType;
    };
}

export interface GetAttractionClinicsFilter {
    confirmationType?: BookingConfirmationType;
}

export enum BookingConfirmationType {
    SMS = "SMS",
    FEE_PAYMENT = "FEE_PAYMENT",
}

export interface AttractionClinic {
    id: number;
    confirmationType: BookingConfirmationType | null;
}

/** `GET /locations/clinics` item: nearest clinic resolved from the request IP. */
export interface NearestClinic {
    city_id: number;
    clinic_id: number;
}
